export class ChartData {
  public name: string;
  public showLine: boolean = true;
  public pointStyle: string = 'circle';
  public color: string;
  
  public points: Point[];
  
  constructor(name: string, color: string, points: Point[]) {
    this.name = name;
    this.color = color;
    this.points = points;
  }
}

export class Point {
  label: string;
  x: string;
  y: number;
}
